<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="酋长收益" name="total"></el-tab-pane>
      <el-tab-pane label="成员收益" name="detail"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type == 'total'">
      <el-input
        v-model="month"
        size="mini"
        class="search"
        placeholder="按月份搜索（如：202001）"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="tribeCheifProfit">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="月份" prop="month"></el-table-column>
        <el-table-column label="数额" prop="profitAmount"></el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card v-show="type == 'detail'">
      <el-input
        v-model="userId"
        size="mini"
        @change="queryDetailData"
        placeholder="用户ID"
        class="search"
      ></el-input>
      <el-date-picker
        v-model="dateVal"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        class="date-search"
      >
      </el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryDetailData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="tribeMemberProfit">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="数额" prop="profitAmount"></el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="tribeMemberProfitTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterTribeProfit",
  data() {
    return {
      type: "total",
      month: "",
      dateVal: "",
      userId: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getTribeCheifProfit",
      "getTribeMemberProfit",
    ]),
    queryData() {
      let q = {};
      if (this.month) q.month = this.month;
      this.getTribeCheifProfit(q);
    },
    queryDetailData() {
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.dateVal) {
        q.startTime = this.dateVal[0].getTime();
        q.endTime = this.dateVal[1].getTime();
      }
      if (this.userId) q.userId = this.userId;
      this.getTribeMemberProfit(q);
    },
    tabChange() {
      if (this.type == "total") {
        this.queryData();
      } else {
        this.queryDetailData();
      }
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryDetailData();
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "tribeCheifProfit",
      "tribeMemberProfit",
      "tribeMemberProfitTotal",
      "tableAble"
    ]),
  },
  watch: {
    tribeCheifProfit() {
      formatTable();
    },
    tribeMemberProfit() {
      formatTable();
    },
  },
  mounted() {
    this.queryData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
